import Flickity from "flickity";
import "flickity-fade";
import "flickity-as-nav-for";
import "flickity-sync";

import { flickityArrow } from "../utilities/GlobalVars";

export class MediaCarousel extends HTMLElement {
  constructor() {
    super();
    const isMobile = window.matchMedia("(max-width: 640px)").matches;

    const carouselOptions = {
      cellAlign: "center",
      contain: true,
      fade: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      adaptiveHeight: isMobile,
    };

    let carousel = new Flickity(this, carouselOptions);

    // Section events
    document.addEventListener("shopify:block:select", (evt) => {
      const blockId = evt.detail.blockId;
      const carouselItem = document.getElementById(`CarouselItem--${blockId}`);

      if (carouselItem) {
        carousel.select(carouselItem.dataset.index);
      }
    });

    document.addEventListener("shopify:section:load", () => {
      carousel = new Flickity(this, carouselOptions);
      carousel.reloadCells();
    });

    document.addEventListener("shopify:section:unload", () => {
      carousel.destroy();
    });
  }
}

export class MediaCarouselNavigation extends HTMLElement {
  constructor() {
    super();
    const carouselElement = document.getElementById(
      this.getAttribute("nav-for")
    );
    const isMobile = window.matchMedia("(max-width: 640px)").matches;

    const navigationOptions = {
      asNavFor: carouselElement,
      cellAlign: isMobile ? "center" : "left",
      contain: true,
      percentPosition: true,
      wrapAround: true,
      groupCells: true,
      arrowShape: flickityArrow,
    };

    let navigation = new Flickity(this, navigationOptions);

    // Section events
    document.addEventListener("shopify:block:select", (evt) => {
      const blockId = evt.detail.blockId;
      const blockElement = document.getElementById(`Navigation--${blockId}`);

      if (blockElement) {
        navigation.select(blockElement.dataset.index);
      }
    });

    document.addEventListener("shopify:section:load", () => {
      navigation = new Flickity(this, navigationOptions);
      navigation.reloadCells();
    });

    document.addEventListener("shopify:section:unload", () => {
      navigation.destroy();
    });
  }
}

customElements.define("media-carousel", MediaCarousel);
customElements.define("media-carousel-navigation", MediaCarouselNavigation);
